<template>
  <div class="cardsManage">
    <table-list
      title="准考证管理"
      :loading="loading"
      :search-form="searchForm(this)"
      :data="cardList"
      :btns="btns(this)"
      :footer-btns="footerBtns(this)"
      :columns="columns(this)"
      :operates="operates(this)"
      :pager="pager"
      :options="{ selection: true, operatesWidth: 120 }"
      @search="onSearch"
      @selectionChange="handleSelectionChange"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    ></table-list>
    <!-- 上传准考证 -->
    <el-upload
      ref="relationTableImportUpload"
      style="display:none"
      action=""
      :http-request="relationTableImport"
      accept=".pdf"
      :limit="1"
      :file-list="fileMaps"
    >
    </el-upload>
    <!-- 单个上传准考证 -->
    <el-upload
      ref="cardsSingleImportUpload"
      style="display:none"
      action=""
      :http-request="singleFileUploadFn"
      accept=".pdf"
      :limit="1"
      :file-list="fileList"
    >
    </el-upload>
    <ImportFileHistory ref="ImportFileHistory"></ImportFileHistory>
    <CardsPdfDialog ref="CardsPdfDialog"></CardsPdfDialog>
  </div>
</template>
<script>
// 顶部按钮
const btns = _this => [
  {
    label: '上传准考证',
    icon: 'el-icon-upload2',
    method: _this.handleImportCard,
    loading: _this.importLoading,
  },
  {
    label: '上传历史',
    icon: 'el-icon-document',
    method: _this.handleOpenHistory,
  },
]
// 底部按钮
const footerBtns = _this => [
  {
    label: '批量删除',
    method: _this.handleBacthDelete,
    icon: 'el-icon-delete',
    type: 'danger',
  },
]
// 搜索框配置
const searchForm = () => [
  {
    label: '姓名/手机/身份证号',
    prop: 'filter',
  },
]
// 表格列配置
const columns = _this => [
  {
    prop: 'name',
    label: '姓名',
    minWidth: 80,
  },
  {
    prop: 'idCard',
    label: '身份证',
    minWidth: 170,
    twoLines: true,
  },
  {
    prop: 'ticketNum',
    label: '名下准考证数量',
    minWidth: 120,
    twoLines: true,
    render: (h, { row }) => {
      return [
        h(
          'el-button',
          {
            props: {
              type: 'text',
            },
            on: {
              click: () => {
                _this.handleOpenCardDialogFn(row)
              },
            },
          },
          row.ticketNum,
        ),
      ]
    },
  },
  {
    prop: 'updateTime',
    label: '修改时间',
    minWidth: 160,
    sortdata: 2,
  },
  {
    prop: 'createTime',
    label: '创建时间',
    minWidth: 160,
    sortdata: 1,
  },
]
// 表格操作按钮配置
const operates = _this => [
  {
    method: _this.handleImportSingleCardFn,
    label: '上传准考证',
  },
]
import TableList from '@/components/TableList'
import to from 'await-to'
import { cardImport, cardListPage, cardListDelete, cardUploadSingle } from '@/api/apply'
import ImportFileHistory from './components/history'
import CardsPdfDialog from './components/material'
export default {
  name: 'CardsManage',
  components: {
    TableList,
    ImportFileHistory,
    CardsPdfDialog,
  },
  data() {
    return {
      searchForm,
      btns,
      footerBtns,
      columns,
      operates,
      loading: false,
      cardList: [],
      selectList: [],
      pager: {
        total: 0,
        size: 20,
        current: 1,
      },
      queryParams: {},
      fileMaps: [],
      importLoading: false,
      fileList: [],
      currentQuery: {},
    }
  },
  mounted() {
    this.getPDFListFn()
  },
  methods: {
    async getPDFListFn() {
      if (this.loading) return
      const { current, size } = this.pager
      this.loading = true
      const [res, err] = await to(cardListPage({ current, size, ...this.queryParams }))
      this.loading = false
      if (err) return this.$message.warning(err.msg)
      this.cardList = res.data.list
      this.pager.total = res.data.total
    },
    //上传准考证
    handleImportCard() {
      this.$refs['relationTableImportUpload'].$children[0].$refs.input.click()
    },
    async relationTableImport(file) {
      const params = new FormData() //创建FormData
      params.append('file', file.file)
      this.importLoading = true
      const [, err] = await to(cardImport(params))
      this.importLoading = false
      this.fileMaps = []
      if (err)
        return this.$message({ type: 'warning', dangerouslyUseHTMLString: true, message: err.msg })
      this.$message({ message: '导入成功', type: 'success' })
    },
    handleImportSingleCardFn(row) {
      this.currentQuery = row
      this.$refs['cardsSingleImportUpload'].$children[0].$refs.input.click()
    },
    async singleFileUploadFn(file) {
      const params = new FormData() //创建FormData
      params.append('file', file.file)
      params.append('id', this.currentQuery.id)
      const [, err] = await to(cardUploadSingle(params))
      this.fileList = []
      if (err)
        return this.$message({ type: 'warning', dangerouslyUseHTMLString: true, message: err.msg })
      this.$message({ message: '导入成功', type: 'success' })
      this.getPDFListFn()
    },
    //上传历史
    handleOpenHistory() {
      this.$refs.ImportFileHistory.show()
    },
    //准考证弹窗
    handleOpenCardDialogFn(row) {
      this.$refs.CardsPdfDialog.show(row)
    },
    //删除
    async handleBacthDelete() {
      let arr = []
      if (this.selectList.length == 0) return this.$message.warning('请选择要删除的数据')
      this.selectList.map(v => arr.push(v.id))
      this.$confirm(`您确定要删除吗？删除后将无法恢复`, '确认删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const [, err] = await to(cardListDelete({ idList: arr }))
          if (err) return this.$message.warning(err.msg)
          this.$message.success('删除成功')
          this.getPDFListFn()
        })
        .catch(() => {})
    },
    // 查询按钮
    onSearch(queryParams) {
      this.pager.current = 1
      this.queryParams = queryParams
      this.getPDFListFn()
    },
    // 分页
    handleSizeChange(size) {
      this.pager.current = 1
      this.pager.size = size
      this.getPDFListFn()
    },
    handleCurrentChange(current) {
      this.pager.current = current
      this.getPDFListFn()
    },
    handleSelectionChange(val) {
      this.selectList = val
    },
  },
}
</script>
